import React from "react";
import * as S from "./styles";

const Input = ({
  label,
  inputName,
  registerFunction,
  errors,
  variant = "dark",
  ...props
}) => {
  if (!label || !inputName || !registerFunction) return null;

  return (
    <div className="input-container">
      <S.InputContainer>
        <S.InputTextFieldContainer
          invalid={!!errors?.[inputName]}
          variant={variant}
        >
          <label htmlFor={inputName}>{label}</label>
          <input
            {...props}
            {...registerFunction(inputName, { onBlur: props.onBlur })}
            aria-invalid={errors?.[inputName] ? "true" : "false"}
            type="text"
          />
        </S.InputTextFieldContainer>
      </S.InputContainer>

      {errors?.[inputName] && (
        <S.ErrorMessage variant={variant}>
          {errors[inputName].message}
        </S.ErrorMessage>
      )}
    </div>
  );
};

export default Input;
